import React, { useState } from 'react';
import { Send, Loader2, FileDown, Search } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../../context/AuthContext';
import { herunterladen } from '../stammakte/ui';

const fmt = (iso) => (iso ? new Date(iso).toLocaleString('de-DE', { dateStyle: 'short', timeStyle: 'short' }) : '—');
const fehler = (e) => e?.response?.data?.detail || 'Aktion fehlgeschlagen';

export const NachweisKnopf = ({ pfad, name, testId }) => (
  <button type="button" onClick={() => herunterladen(pfad, `Zustimmungsnachweis_${name || ''}.pdf`)} data-testid={testId}
    className="inline-flex items-center gap-1 text-[11px] text-[#b8893d] hover:text-[#1B3A5C]"><FileDown className="w-3 h-3" />Nachweis (PDF)</button>
);

export const OffeneListe = ({ nutzer, onDone }) => {
  const erst = nutzer.filter((u) => u.erstzugang && u.verknuepft);
  const [wahl, setWahl] = useState([]);
  const [busy, setBusy] = useState(false);
  const toggle = (id) => setWahl((w) => (w.includes(id) ? w.filter((x) => x !== id) : [...w, id]));
  const senden = async () => {
    if (!window.confirm(`Erinnerung an ${wahl.length} Mandant${wahl.length === 1 ? '' : 'en'} per E-Mail senden?`)) return;
    setBusy(true);
    try { const r = await api.post('/admin/rechtstexte/erstzugang-erinnern', { user_ids: wahl }); const f = r.data.fehler?.length || 0; if (f) toast.error(`${r.data.gesendet} gesendet, ${f} fehlgeschlagen: ${r.data.fehler.join(', ')}`); else toast.success(`${r.data.gesendet} Erinnerung(en) gesendet`); setWahl([]); onDone(); }
    catch (e) { toast.error(fehler(e)); }
    setBusy(false);
  };
  return (
    <>
      {erst.length > 0 && (
        <div className="flex flex-wrap items-center gap-2 px-4 py-2 bg-[#fbf7f0] border-b border-gray-100 text-xs" data-testid="rt-erst-leiste">
          <span className="text-[#1B3A5C]">{erst.length} warten auf die Erstbestätigung</span>
          <button type="button" onClick={() => setWahl(wahl.length === erst.length ? [] : erst.map((u) => u.user_id))} className="text-[#b8893d] underline" data-testid="rt-erst-alle">{wahl.length === erst.length ? 'Auswahl aufheben' : 'alle auswählen'}</button>
          <button type="button" onClick={senden} disabled={!wahl.length || busy} data-testid="rt-erst-erinnern"
            className="ml-auto inline-flex items-center gap-1.5 px-3 py-1.5 text-[10px] tracking-wider bg-[#1B3A5C] text-white hover:bg-[#b8893d] disabled:opacity-40 transition-colors">
            {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Send className="w-3 h-3" />} ERINNERUNG SENDEN ({wahl.length})
          </button>
        </div>
      )}
      <ul className="divide-y divide-gray-50 max-h-96 overflow-y-auto" data-testid="rt-offen-liste">
        {nutzer.length === 0 && <li className="px-4 py-6 text-center text-xs text-[#7a8a99]">Alle Portal-Nutzer haben die aktuellen Fassungen bestätigt.</li>}
        {nutzer.map((u) => (
          <li key={u.user_id} className="px-4 py-2 text-xs flex flex-wrap items-center gap-2" data-testid={`rt-offen-${u.user_id}`}>
            {u.erstzugang && u.verknuepft ? <input type="checkbox" checked={wahl.includes(u.user_id)} onChange={() => toggle(u.user_id)} className="accent-[#b8893d]" data-testid={`rt-erst-wahl-${u.user_id}`} /> : <span className="w-[13px]" />}
            <span className="text-[#1B3A5C]">{u.name || '—'}</span><span className="text-[#7a8a99]">{u.email}</span>
            {u.erstzugang && <span className="px-1.5 py-0.5 rounded-sm bg-[#1B3A5C] text-[#e0b56a] text-[9.5px] tracking-wider uppercase">Erstzugang</span>}
            {!u.verknuepft && <span className="text-amber-700" data-testid={`rt-unverknuepft-${u.user_id}`}>nicht mit Mandant verknüpft</span>}
            <span className="text-[#7a8a99]">{u.letzte_anmeldung ? `zuletzt angemeldet ${fmt(u.letzte_anmeldung)}` : 'noch nie angemeldet'}</span>
            {u.erinnert_anzahl > 0 && <span className="text-[#8f6a2b]" data-testid={`rt-erinnert-${u.user_id}`}>erinnert {u.erinnert_anzahl}× · zuletzt {fmt(u.erinnert_am)}</span>}
            <span className="ml-auto flex items-center gap-3"><span className="text-rose-700">{u.fehlt.map((f) => (f === 'agb' ? 'AGB' : 'Datenschutz')).join(', ')}</span>
              <NachweisKnopf pfad={`/admin/rechtstexte/nachweis/${u.user_id}.pdf`} name={u.email} testId={`rt-nachweis-offen-${u.user_id}`} /></span>
          </li>
        ))}
      </ul>
    </>
  );
};

export const NachweisSuche = () => {
  const [q, setQ] = useState('');
  const [items, setItems] = useState(null);
  const suchen = (e) => { e.preventDefault(); api.get('/admin/rechtstexte/nutzer', { params: { q } }).then((r) => setItems(r.data.items || [])).catch(() => setItems([])); };
  return (
    <div className="bg-white border border-gray-200" data-testid="rt-nachweis">
      <p className="px-4 py-3 border-b border-gray-100 text-[11px] tracking-[0.2em] uppercase text-[#1B3A5C] font-semibold">Zustimmungsnachweis abrufen</p>
      <form onSubmit={suchen} className="flex gap-2 p-3">
        <label className="relative flex-1"><Search className="w-3.5 h-3.5 absolute left-2.5 top-1/2 -translate-y-1/2 text-[#7a8a99]" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Name, E-Mail oder Mandantennummer" className="w-full h-9 pl-8 pr-2 border border-gray-200 text-sm outline-none focus:border-[#b8893d]" data-testid="rt-nachweis-suche" /></label>
        <button type="submit" className="px-4 text-[10px] tracking-wider bg-[#1B3A5C] text-white hover:bg-[#b8893d]" data-testid="rt-nachweis-suchen">SUCHEN</button>
      </form>
      {items && <ul className="divide-y divide-gray-50 max-h-72 overflow-y-auto" data-testid="rt-nachweis-liste">
        {!items.length && <li className="px-4 py-4 text-xs text-[#7a8a99]">Keine Portal-Nutzer gefunden.</li>}
        {items.map((u) => (
          <li key={u.user_id} className="px-4 py-2 text-xs flex flex-wrap items-center gap-2" data-testid={`rt-nachweis-${u.user_id}`}>
            <span className="text-[#1B3A5C]">{u.name || '—'}</span><span className="text-[#7a8a99]">{u.email}</span>
            <span className="text-[#7a8a99]">{u.mandanten_nrs.map((m) => `M-${m}`).join(', ')}</span>
            <span className={u.fehlt.length ? 'text-rose-700' : 'text-emerald-700'}>{u.fehlt.length ? 'offen' : 'bestätigt'}</span>
            <span className="ml-auto"><NachweisKnopf pfad={`/admin/rechtstexte/nachweis/${u.user_id}.pdf`} name={u.email} testId={`rt-nachweis-pdf-${u.user_id}`} /></span>
          </li>
        ))}
      </ul>}
    </div>
  );
};
